// import Server from './server';

// class API extends Server {
//     // 登录
//     async login(params={}){
//         try {
//             console.log(params)
//             const result = await this.axios('POST', params,'/appFree/appGuest/pcLogin.do');
//             console.log(result);
//             if(result) {
//                 return(result)
//             };
//           } catch (err) {
//             throw err;
//         }
//     }

//     async getRequest(params={},url){
//         try {
//             console.log(params)
//             const result = await this.axios('POST', params,url);
//             console.log(result);
//             if(result) {
//                 return(result)
//             };
//           } catch (err) {
//             throw err;
//         }
//     }
// }

// export default new API();


import { http, http2, http3 } from './http.js'; // 导入我们封装好的axios对象
import servers from './server.js'; // 导入我们封装好的apis对象


export const taskReport = (params = {}, okCallBack, errCallBack) => { // 从外部接受参数，没有参数默认为空对象(新)
    return http('POST', servers.taskReport, params, okCallBack, errCallBack)
}

export const getMember = (okCallBack, errCallBack) => { // 人员切换
    return http('GET', servers.getMember, okCallBack, errCallBack)
}
export const getContactPerson = (okCallBack, errCallBack) => { // 联系人组管理新增
    return http('GET', servers.getContactPerson, okCallBack, errCallBack)
}
export const getLinkManListBylk = (params = {}, okCallBack, errCallBack) => { // 联系人组管理详情
    return http('GET', servers.getLinkManListBylk, params, okCallBack, errCallBack)
}


export const getExpenditure = (okCallBack, errCallBack) => { //获取顶级经费
    return http('GET', servers.getExpenditure, okCallBack, errCallBack)
}
export const getExpenditure2 = (okCallBack, errCallBack) => { //获取顶级经费
    return http('GET', servers.getExpenditure2, okCallBack, errCallBack)
}
export const ExpensesRound = (params = {}, okCallBack, errCallBack) => { // 圆饼图
    return http('GET', servers.ExpensesRound, params, okCallBack, errCallBack)
}
export const ExpensesaddBroken = (params = {}, okCallBack, errCallBack) => { // 折线图2
    return http('GET', servers.ExpensesaddBroken, params, okCallBack, errCallBack)
}

export const expenditureList = (params = {}, okCallBack, errCallBack) => { // 圆饼图下table
    return http('GET', servers.expenditureList, params, okCallBack, errCallBack)
}
export const expenditureList2 = (params = {}, okCallBack, errCallBack) => {
    return http('GET', servers.expenditureList2, params, okCallBack, errCallBack)
}
export const ExpensesBroken = (params = {}, okCallBack, errCallBack) => { // 折现图
    return http('GET', servers.ExpensesBroken, params, okCallBack, errCallBack)
}

export const updateBaseUser = (params = {}, okCallBack, errCallBack) => {//首页自定义修改
    return http('GET', servers.updateBaseUser, params, okCallBack, errCallBack)
}
export const reportSave = (params = {}, okCallBack, errCallBack) => {//报告保存
    return http('GET', servers.reportSave, params, okCallBack, errCallBack)
}
export const reportSubmit = (params = {}, okCallBack, errCallBack) => {//报告提交
    return http('GET', servers.reportSubmit, params, okCallBack, errCallBack)
}

export const review = (params = {}, okCallBack, errCallBack) => {//报告审核人数组
    return http('GET', servers.review, params, okCallBack, errCallBack)
}


export const reqByGet = (url, params = {}, okCallBack, errCallBack) => {
    return http('GET', url, params, okCallBack, errCallBack)
}

export const reqByPost = (url, params = {}, okCallBack, errCallBack) => {
    return http('POST', url, params, okCallBack, errCallBack)
}


export const reqByPost2 = (url, data, okCallBack, errCallBack) => {
    return http3('POST', url, data, okCallBack, errCallBack)
}

export const getEqUseListCount = (params = {}, okCallBack, errCallBack) => { // 登录页面初始化接口
    return http('GET', servers.getEqUseListCount, params, okCallBack, errCallBack)
}


export const initialPage = (params = {}, okCallBack, errCallBack) => { // 登录页面初始化接口
    return http('GET', servers.initial, params, okCallBack, errCallBack)
}

export const loginIn = (params = {}, okCallBack, errCallBack) => { // 从外部接受参数，没有参数默认为空对象
    return http('POST', servers.login, params, okCallBack, errCallBack)
}

export const loginOut = (params = {}, okCallBack, errCallBack) => { // 从外部接受参数，没有参数默认为空对象
    return http('POST', servers.loginOut, params, okCallBack, errCallBack)
}

export const signLab = (params = {}, okCallBack, errCallBack) => { // 从外部接受参数，没有参数默认为空对象
    return http('POST', servers.signLab, params, okCallBack, errCallBack)
}

export const signUser = (params = {}, okCallBack, errCallBack) => { // 从外部接受参数，没有参数默认为空对象
    return http('POST', servers.signUser, params, okCallBack, errCallBack)
}

export const getPiList = (params = {}, okCallBack, errCallBack) => { // 从外部接受参数，没有参数默认为空对象
    return http('POST', servers.piList, params, okCallBack, errCallBack)
}

export const getIndexData = (params = {}, okCallBack, errCallBack) => { // 2.47首页接口
    return http('GET', servers.indexData, params, okCallBack, errCallBack)
}

export const getCountIndexData = (params = {}, okCallBack, errCallBack) => { // 2.50首页统计
    return http('GET', servers.countIndexData, params, okCallBack, errCallBack)
}

export const switchLabHandle = (params = {}, okCallBack, errCallBack) => { // 2.6实验室下拉改变，更新缓存
    return http('POST', servers.switchLab, params, okCallBack, errCallBack)
}


export const dealMsgReadPost = (params = {}, okCallBack, errCallBack) => { // 2.46标记消息已读
    return http('POST', servers.dealMsgRead, params, okCallBack, errCallBack)
}

export const getDataList_box = (params = {}, okCallBack, errCallBack) => { // 2.22获取字典分类下拉
    return http('GET', servers.dataList, params, okCallBack, errCallBack)
}

export const upload = (params = {}, okCallBack, errCallBack) => { // 多文件上传
    return http('POST', servers.upload, params, okCallBack, errCallBack)
}

export const getOrgList_box = (params = {}, okCallBack, errCallBack) => { //机构下拉列表
    return http('GET', servers.orgListBox, params, okCallBack, errCallBack)
}

export const getLabList_box = (params = {}, okCallBack, errCallBack) => { //实验室下拉列表
    return http('GET', servers.labListBox, params, okCallBack, errCallBack)
}

export const getRoleList_box = (params = {}, okCallBack, errCallBack) => { //用户角色下拉列表
    return http('GET', servers.RoleListBox, params, okCallBack, errCallBack)
}

export const getlabRoleList_box = (params = {}, okCallBack, errCallBack) => { //2.41实验室角色下拉列表（当前用户）——实验室
    return http('GET', servers.labRoleListBox, params, okCallBack, errCallBack)
}

export const getlabRoleList_platform_box = (params = {}, okCallBack, errCallBack) => { //2.41实验室角色下拉列表——平台
    return http('GET', servers.labRoleListBox_platform, params, okCallBack, errCallBack)
}

export const getComboxList_box = (params = {}, okCallBack, errCallBack) => { //设备，培训类型下拉列表
    return http('GET', servers.comboxListBox, params, okCallBack, errCallBack)
}

export const getTrainUserList_box = (params = {}, okCallBack, errCallBack) => { // 查询2.23培训备选用户列表
    return http('GET', servers.trainUserListBox, params, okCallBack, errCallBack)
}

export const getOrgList = (params = {}, okCallBack, errCallBack) => { // 查询机构列表
    return http('GET', servers.orgList, params, okCallBack, errCallBack)
}

export const getOrgInfo = (params = {}, okCallBack, errCallBack) => { // 获取机构详情
    return http('GET', servers.orgInfo, params, okCallBack, errCallBack)
}

export const addOrg = (params = {}, okCallBack, errCallBack) => { // 添加机构
    return http('POST', servers.addOrg, params, okCallBack, errCallBack)
}

export const getLabList = (params = {}, okCallBack, errCallBack) => { // 查询实验室（平台）列表
    return http('GET', servers.labList, params, okCallBack, errCallBack)
}

export const getLabInfo = (params = {}, okCallBack, errCallBack) => { // 查询实验室详情
    return http('GET', servers.labInfo, params, okCallBack, errCallBack)
}

export const addLab = (params = {}, okCallBack, errCallBack) => { // 添加实验室
    return http('POST', servers.addLab, params, okCallBack, errCallBack)
}

export const getUserList = (params = {}, okCallBack, errCallBack) => { // 查询实验室用户列表(平台管理员)
    return http('GET', servers.userList, params, okCallBack, errCallBack)
}

export const getLab = (params = {}, okCallBack, errCallBack) => { // 2.43获取实验室详情数据(实验室管理（实验室）)
    return http('GET', servers.getLab, params, okCallBack, errCallBack)
}

export const addUserAccount = (params = {}, okCallBack, errCallBack) => { // 添加实验室（平台）账户
    return http('POST', servers.addUserAccount, params, okCallBack, errCallBack)
}

export const userPswReset = (params = {}, okCallBack, errCallBack) => { // 修改密码
    return http('POST', servers.pswReset, params, okCallBack, errCallBack)
}

export const getLabUserList = (params = {}, okCallBack, errCallBack) => { // 查询实验室用户列表 (实验室管理员)
    return http('GET', servers.labUserList, params, okCallBack, errCallBack)
}

export const getSignUserList = (params = {}, okCallBack, errCallBack) => { // 查询实验室用户列表 (实验室管理员)
    return http('GET', servers.getSignUserList, params, okCallBack, errCallBack)
}

export const getLabUserInfo = (params = {}, okCallBack, errCallBack) => { // 2.16获取实验室用户详情数据
    return http('GET', servers.getLabUserInfo, params, okCallBack, errCallBack)
}


export const getAllUserList = (params = {}, okCallBack, errCallBack) => {  // 查询实验室用户列表(包括外部人员)
    return http('GET', servers.allUserList, params, okCallBack, errCallBack)
}

export const getTrainList = (params = {}, okCallBack, errCallBack) => { // 查询培训管理列表
    return http('GET', servers.trainList, params, okCallBack, errCallBack)
}

export const addTrain = (params = {}, okCallBack, errCallBack) => { // 查询2.23培训备选用户列表
    return http('GET', servers.addTrain, params, okCallBack, errCallBack)
}

export const endTrain = (params = {}, okCallBack, errCallBack) => { // 完结培训
    return http('GET', servers.endTrain, params, okCallBack, errCallBack)
}

export const getTrainInfo = (params = {}, okCallBack, errCallBack) => { // 查询培训详情
    return http('GET', servers.trainInfo, params, okCallBack, errCallBack)
}

export const leaveList = (params = {}, okCallBack, errCallBack) => { // 2.37获取请假列表
    return http('GET', servers.leaveList, params, okCallBack, errCallBack)
}

export const leaveInfo = (params = {}, okCallBack, errCallBack) => { // 2.38请假详情
    return http('GET', servers.leaveInfo, params, okCallBack, errCallBack)
}

export const auditLeave = (params = {}, okCallBack, errCallBack) => { // 2.38请假详情
    return http('POST', servers.auditLeave, params, okCallBack, errCallBack)
}

export const getAttendanceSetting = (params = {}, okCallBack, errCallBack) => { //获取考勤设置数据
    return http('GET', servers.attendanceSettingData, params, okCallBack, errCallBack)
}

export const addAttendanceSetting = (params = {}, okCallBack, errCallBack) => { //获取考勤设置数据
    return http('GET', servers.addAttendance, params, okCallBack, errCallBack)
}

export const getAttendanceList = (params = {}, okCallBack, errCallBack) => { //获取考勤设置数据
    return http('GET', servers.attendanceList, params, okCallBack, errCallBack)
}

export const userEdit = (params = {}, okCallBack, errCallBack) => { // 编辑个人信息
    return http('GET', servers.userEdit, params, okCallBack, errCallBack)
}

export const getUserAudiList = (params = {}, okCallBack, errCallBack) => { // 2.48个人中心接口（我的申请、待我审批、我已审批、抄送我的）
    return http('GET', servers.userAudiList, params, okCallBack, errCallBack)
}

export const postSuggest = (params = {}, okCallBack, errCallBack) => { // 编辑个人信息
    return http('POST', servers.suggest, params, okCallBack, errCallBack)
}

export const getSuggestList = (params = {}, okCallBack, errCallBack) => { // 2.45查询吐槽列表
    return http('GET', servers.suggestList, params, okCallBack, errCallBack)
}

export const getNoticeList = (params = {}, okCallBack, errCallBack) => { // 2.32查询公告管理列表
    return http('GET', servers.noticeList, params, okCallBack, errCallBack)
}

export const addNotice = (params = {}, okCallBack, errCallBack) => { // 2.32添加或修改公告
    return http('POST', servers.addNotice, params, okCallBack, errCallBack)
}

export const topNotice = (params = {}, okCallBack, errCallBack) => { // 2.35置顶公告
    return http('POST', servers.topNotice, params, okCallBack, errCallBack)
}

export const delNotice = (params = {}, okCallBack, errCallBack) => { // 2.36删除公告
    return http('POST', servers.delNotice, params, okCallBack, errCallBack)
}

export const getMsgList = (params = {}, okCallBack, errCallBack) => { // 获取消息列表
    return http('GET', servers.msgList, params, okCallBack, errCallBack)
}

export const getMsgNum = (params = {}, okCallBack, errCallBack) => { // 2.2获取消息数量
    return http('GET', servers.msgNum, params, okCallBack, errCallBack)
}

export const getMsgNewNum = (params = {}, okCallBack, errCallBack) => { // 2.2获取消息未读数量
    return http('GET', servers.msgNewNum, params, okCallBack, errCallBack)
}

export const getMsgUpdateInvite = (params = {}, okCallBack, errCallBack) => { // 2.51邀约操作
    return http('GET', servers.msgUpdateInvite, params, okCallBack, errCallBack)
}

export const getProInviteInfo = (params = {}, okCallBack, errCallBack) => { // 2.53邀约详情查询
    return http('GET', servers.proInviteInfo, params, okCallBack, errCallBack)
}

export const getMsgJobInfo = (params = {}, okCallBack, errCallBack) => { // 2.52任务详情
    return http('GET', servers.msgJobInfo, params, okCallBack, errCallBack)
}

export const getProList = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.getProList, params, okCallBack, errCallBack)
}

export const getProChildList = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.getProChildList, params, okCallBack, errCallBack)
}

export const updateColl = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.updateColl, params, okCallBack, errCallBack)
}

export const subPro = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.subPro, params, okCallBack, errCallBack)
}

export const getUserIdsCombox = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.getUserIdsCombox, params, okCallBack, errCallBack)
}

export const getUserId = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.getUserId, params, okCallBack, errCallBack)
}

export const getFlowInfo = (params = {}, okCallBack, errCallBack) => { // 2.19获取审核流程列表
    return http('GET', servers.flowInfo, params, okCallBack, errCallBack)
}

export const updateFlowInfo = (params = {}, okCallBack, errCallBack) => { // 2.20新增修改审核流程
    return http('POST', servers.addFlow, params, okCallBack, errCallBack)
}

export const getReaList = (params = {}, okCallBack, errCallBack) => { // 2.20新增修改审核流程
    return http('GET', servers.reaList, params, okCallBack, errCallBack)
}
export const getRepairListByUser = (params = {}, okCallBack, errCallBack) => {
    return http('GET', servers.repairListByUser, params, okCallBack, errCallBack)
}

export const getMedicineInfo = (params = {}, okCallBack, errCallBack) => { // 2.25试剂耗材详情和修改初始化
    return http('GET', servers.medicineInfo, params, okCallBack, errCallBack)
}

export const getMedicineBatchList = (params = {}, okCallBack, errCallBack) => { // 2.36试剂耗材详情批次列表  未实现
    return http('GET', servers.medicineBatchList, params, okCallBack, errCallBack)
}

export const getMedicineCodeList = (params = {}, okCallBack, errCallBack) => { // 2.37试剂耗材详情记录列表  未实现
    return http('GET', servers.medicineCodeList, params, okCallBack, errCallBack)
}

export const getMedicineTypeInfo = (params = {}, okCallBack, errCallBack) => { // 2.35试剂耗材操作记录表（申领、申购、入库、报损）
    return http('GET', servers.medicineTypeInfo, params, okCallBack, errCallBack)
}

export const addMedicine = (params = {}, okCallBack, errCallBack) => { // 2.24添加、修改试剂耗材
    return http('POST', servers.medicinePost, params, okCallBack, errCallBack)
}

export const medicineInPost = (params = {}, okCallBack, errCallBack) => { // 2.32试剂耗材入库
    return http('POST', servers.medicineInPost, params, okCallBack, errCallBack)
}

export const medicineAlarm = (params = {}, okCallBack, errCallBack) => { // 2.26试剂耗材过期、余量预警设置
    return http('POST', servers.medicineAlarm, params, okCallBack, errCallBack)
}

export const getMedicineBackIn = (params = {}, okCallBack, errCallBack) => { // 2.38试剂耗材归还初始化列表
    return http('POST', servers.medicineBackIn, params, okCallBack, errCallBack)
}

export const medicineBackInPost = (params = {}, okCallBack, errCallBack) => { // 试剂耗材归还提交
    return http('POST', servers.medicineBackInPost, params, okCallBack, errCallBack)
}

export const medicineDel = (params = {}, okCallBack, errCallBack) => { //2.27试剂耗材删除
    return http('POST', servers.medicineDel, params, okCallBack, errCallBack)
}

export const medicineGetInitial = (params = {}, okCallBack, errCallBack) => { // 2.28试剂耗材申领单初始化
    return http('GET', servers.medicineGetInitial, params, okCallBack, errCallBack)
}

export const medicineGetPost = (params = {}, okCallBack, errCallBack) => { // 试剂耗材申领单提交
    return http('POST', servers.medicineGetPost, params, okCallBack, errCallBack)
}

export const medicineBuyInitial = (params = {}, okCallBack, errCallBack) => { // 2.30试剂耗材申购单初始化
    return http('GET', servers.medicineBuyInitial, params, okCallBack, errCallBack)
}

export const medicineBuyPost = (params = {}, okCallBack, errCallBack) => { //2.31试剂耗材申购单提交
    return http('POST', servers.medicineBuyPost, params, okCallBack, errCallBack)
}

export const getMedicineBadList = (params = {}, okCallBack, errCallBack) => { //试剂耗材报损初始化 不分页
    return http('GET', servers.medicineBadList, params, okCallBack, errCallBack)
}

export const medicineBadPost = (params = {}, okCallBack, errCallBack) => { //2.34试剂耗材报损
    return http('POST', servers.medicineBadPost, params, okCallBack, errCallBack)
}

export const getInstrumentList = (params = {}, okCallBack, errCallBack) => { //设备列表
    return http('POST', servers.instrumentList, params, okCallBack, errCallBack)
}

export const getInstrumentInfo = (params = {}, okCallBack, errCallBack) => { //2.23获取设备详情数据
    return http('GET', servers.instrumentInfo, params, okCallBack, errCallBack)
}

export const instrumentPost = (params = {}, okCallBack, errCallBack) => { //2.21添加、修改设备
    return http('GET', servers.instrumentPost, params, okCallBack, errCallBack)
}

export const instrumentDel = (params = {}, okCallBack, errCallBack) => { //2.22删除设备
    return http('POST', servers.instrumentDel, params, okCallBack, errCallBack)
}

export const getAudiGetList = (params = {}, okCallBack, errCallBack) => { //2.40申领审批列表
    return http('GET', servers.audiGetList, params, okCallBack, errCallBack)
}

export const getAudiGetInfo = (params = {}, okCallBack, errCallBack) => { //2.41申领审批查看
    return http('GET', servers.audiGetInfo, params, okCallBack, errCallBack)
}

export const getAudiGetSee = (params = {}, okCallBack, errCallBack) => { //2.42申领分配查看
    return http('GET', servers.audiGetSee, params, okCallBack, errCallBack)
}

export const audiGetPost = (params = {}, okCallBack, errCallBack) => { //2.43申领审批（不提供对计划单修改）
    return http('GET', servers.audiGetPost, params, okCallBack, errCallBack)
}

export const getAudiBuyList = (params = {}, okCallBack, errCallBack) => { //2.44申购审批列表
    return http('GET', servers.audiBuyList, params, okCallBack, errCallBack)
}

export const getAudiBuyInfo = (params = {}, okCallBack, errCallBack) => { //2.45申购审批查看
    return http('GET', servers.audiBuyInfo, params, okCallBack, errCallBack)
}

export const audiBuyPost = (params = {}, okCallBack, errCallBack) => { //2.46申购审批
    return http('GET', servers.audiBuyPost, params, okCallBack, errCallBack)
}

export const getJobList = (params = {}, okCallBack, errCallBack) => { //2.46申购审批
    return http('GET', servers.getJobList, params, okCallBack, errCallBack)
}

export const getReportList = (params = {}, okCallBack, errCallBack) => { //2.46申购审批
    return http('GET', servers.getReportList, params, okCallBack, errCallBack)
}

export const getProInfo = (params = {}, okCallBack, errCallBack) => { //2.46申购审批
    return http('GET', servers.proInfo, params, okCallBack, errCallBack)
}

export const getDocList = (params = {}, okCallBack, errCallBack) => { //2.46申购审批
    return http('GET', servers.getDocList, params, okCallBack, errCallBack)
}

export const updatedelDoc = (params = {}, okCallBack, errCallBack) => { //2.46申购审批
    return http('GET', servers.updatedelDoc, params, okCallBack, errCallBack)
}

export const updateJobState = (params = {}, okCallBack, errCallBack) => { //2.46申购审批
    return http('GET', servers.updateJobState, params, okCallBack, errCallBack)
}

export const updateurgeJob = (params = {}, okCallBack, errCallBack) => { //2.46申购审批
    return http('GET', servers.updateurgeJob, params, okCallBack, errCallBack)
}

export const subJob = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.subJob, params, okCallBack, errCallBack)
}

export const subProState = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.subProState, params, okCallBack, errCallBack)
}

export const updateupDoc = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.updateupDoc, params, okCallBack, errCallBack)
}

export const getJobInfo = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.getJobInfo, params, okCallBack, errCallBack)
}

export const updateJobDel = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.updateJobDel, params, okCallBack, errCallBack)
}

export const updatewarnJob = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.updatewarnJob, params, okCallBack, errCallBack)
}

export const getDocInfo = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.getDocInfo, params, okCallBack, errCallBack)
}

export const getReportInfo = (params = {}, okCallBack, errCallBack) => { // 
    return http('POST', servers.getReportInfo, params, okCallBack, errCallBack)
}

// 统计类
export const getStaticProTime = (params = {}, okCallBack, errCallBack) => { // 2.1Pc端今日实时统计（第一阶段）
    return http('GET', servers.staticProTime, params, okCallBack, errCallBack)
}

export const getStaticProList = (params = {}, okCallBack, errCallBack) => { // 2.1参与项目list（第一阶段）
    return http('GET', servers.staticProList, params, okCallBack, errCallBack)
}

export const getStaticFinishPer = (params = {}, okCallBack, errCallBack) => { // 2.2Pc端项目进度情况（第一阶段）
    return http('GET', servers.staticProFinishPer, params, okCallBack, errCallBack)
}

export const getStaticProTaskOrMember = (params = {}, okCallBack, errCallBack) => { // 2.3Pc端任务人员（第一阶段）
    return http('GET', servers.staticProTaskOrMember, params, okCallBack, errCallBack)
}

export const getStaticProRealInfo = (params = {}, okCallBack, errCallBack) => { // 2.4Pc端耗材成本（第一阶段）
    return http('GET', servers.staticProRealInfo, params, okCallBack, errCallBack)
}

export const getStaticProFinishPro = (params = {}, okCallBack, errCallBack) => { //2.5Pc端完成进度（第一阶段）
    return http('GET', servers.staticProFinishPro, params, okCallBack, errCallBack)
}

export const getStaticProExpiryRate = (params = {}, okCallBack, errCallBack) => { //2.11Pc端项目过期率/任务过期率（第二阶段）
    return http('GET', servers.staticProExpiryRate, params, okCallBack, errCallBack)
}

export const getStaticProOrTaskInfo = (params = {}, okCallBack, errCallBack) => { //2.13Pc端项目任务状况（第二阶段）
    return http('GET', servers.staticProOrTaskInfo, params, okCallBack, errCallBack)
}

export const getStaticPersonWeekAtt = (params = {}, okCallBack, errCallBack) => { //2.5周出勤率（第一阶段）
    return http('GET', servers.staticPersonWeekAtt, params, okCallBack, errCallBack)
}

export const getSttaticPersonMonthList = (params = {}, okCallBack, errCallBack) => { //本月考勤榜单
    return http('GET', servers.staticPersonMonthList, params, okCallBack, errCallBack)
}

export const getStaticPersonMonthData = (params = {}, okCallBack, errCallBack) => { //月考勤列表
    return http('GET', servers.staticPersonMonthTableList, params, okCallBack, errCallBack)
}

export const getStaticReaInfoByMonth = (params = {}, okCallBack, errCallBack) => { //Pc端月耗材成本情况（不含列表）
    return http('GET', servers.staticReaInfoByMonth, params, okCallBack, errCallBack)
}

export const getStaticRealListByMonth = (params = {}, okCallBack, errCallBack) => { //耗材成本列表
    return http('GET', servers.staticRealListByMonth, params, okCallBack, errCallBack)
}

export const getStaticReaList = (params = {}, okCallBack, errCallBack) => { //2.30所有耗材list（第一阶段）
    return http('GET', servers.staticReaList, params, okCallBack, errCallBack)
}

export const getStaticReaInfo = (params = {}, okCallBack, errCallBack) => { //耗材备用库占比情况（第二阶段）已完成
    return http('GET', servers.staticReaInfo, params, okCallBack, errCallBack)
}


export const addImportIns = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.addImportIns, params, okCallBack, errCallBack)
}

export const getLinkUserList = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.getLinkUserList, params, okCallBack, errCallBack)
}

export const addUserLink = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.addUserLink, params, okCallBack, errCallBack)
}

export const getLinkUserInfo = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.getLinkUserInfo, params, okCallBack, errCallBack)
}

export const deleteLinkInfo = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.deleteLinkInfo, params, okCallBack, errCallBack)
}

export const getLinkGroupList = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.getLinkGroupList, params, okCallBack, errCallBack)
}

export const addUserGroup = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.addUserGroup, params, okCallBack, errCallBack)
}

export const getLinkGroupInfo = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.getLinkGroupInfo, params, okCallBack, errCallBack)
}

export const deleteGroupInfo = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.deleteGroupInfo, params, okCallBack, errCallBack)
}

export const subHarvest = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.subHarvest, params, okCallBack, errCallBack)
}

export const getProjectTree = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.getProjectTree, params, okCallBack, errCallBack)
}

export const getHarvestList = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.getHarvestList, params, okCallBack, errCallBack)
}
export const getHarvestInfo = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.getHarvestInfo, params, okCallBack, errCallBack)
}
export const deleteHarvest = (params = {}, okCallBack, errCallBack) => { //导入
    return http('GET', servers.deleteHarvest, params, okCallBack, errCallBack)
}


// 1.1.0版本
// 设备
export const getEqAdminList = (params = {}, okCallBack, errCallBack) => { //2.1.6设备管理列表
    return http('GET', servers.eqAdminList, params, okCallBack, errCallBack)
}

export const getEqAdminInfo = (params = {}, okCallBack, errCallBack) => { //2.1.7设备管理详情
    return http('GET', servers.eqAdminInfo, params, okCallBack, errCallBack)
}

export const eqAdminAdd = (params = {}, okCallBack, errCallBack) => { //2.1.8设备管理新增/修改
    return http('POST', servers.eqAdminAdd, params, okCallBack, errCallBack)
}

export const eqAdminDel = (params = {}, okCallBack, errCallBack) => { //2.1.9设备管理删除
    return http('POST', servers.eqAdminDel, params, okCallBack, errCallBack)
}

export const eqAdminStEdit = (params = {}, okCallBack, errCallBack) => { //2.1.10设备管理状态调整
    return http('POST', servers.eqAdminStEdit, params, okCallBack, errCallBack)
}

export const eqAdminImport = (params = {}, okCallBack, errCallBack) => { //2.1.11设备导入接口
    return http('POST', servers.eqAdminImport, params, okCallBack, errCallBack)
}

export const addImportReagent = (params = {}, okCallBack, errCallBack) => { //2.1.11设备导入接口
    return http('POST', servers.addImportReagent, params, okCallBack, errCallBack)
}

export const getEqUse = (params = {}, okCallBack, errCallBack) => { //2.1.16设备已使用情况
    return http('GET', servers.eqAdminUse, params, okCallBack, errCallBack)
}

export const getEqRepair = (params = {}, okCallBack, errCallBack) => { //2.1.17设备维修情况
    return http('GET', servers.eqAdminRepair, params, okCallBack, errCallBack)
}

export const getEqAppointList = (params = {}, okCallBack, errCallBack) => { //2.1.13设备预约列表
    return http('GET', servers.eqAppointList, params, okCallBack, errCallBack)
}

export const getEqAppointInfo = (params = {}, okCallBack, errCallBack) => { //2.1.14设备预约详情
    return http('GET', servers.eqAppointInfo, params, okCallBack, errCallBack)
}

export const getEqAppointBeList = (params = {}, okCallBack, errCallBack) => { //2.1.15设备已预约情况
    return http('GET', servers.eqAppointBeList, params, okCallBack, errCallBack)
}

export const eqAppointApply = (params = {}, okCallBack, errCallBack) => { //2.1.18设备预约申请
    return http('POST', servers.eqAppointApply, params, okCallBack, errCallBack)
}

export const getEqUserAppointList = (params = {}, okCallBack, errCallBack) => { //2.1.23已预约列表
    return http('GET', servers.eqUserAppointList, params, okCallBack, errCallBack)
}

export const getEqUserUse = (params = {}, okCallBack, errCallBack) => { //2.1.25使用列表
    return http('GET', servers.eqUserUse, params, okCallBack, errCallBack)
}

export const getEqUserUseReturn = (params = {}, okCallBack, errCallBack) => { //2.1.26设备归还接口
    return http('GET', servers.eqUserUseReturn, params, okCallBack, errCallBack)
}

export const getEqUserUseEvalute = (params = {}, okCallBack, errCallBack) => { //2.1.27预约信息评价
    return http('GET', servers.eqUserUseEvalute, params, okCallBack, errCallBack)
}

export const getEqUserAppointInfo = (params = {}, okCallBack, errCallBack) => { //2.1.22预约信息详情
    return http('GET', servers.eqUserAppointInfo, params, okCallBack, errCallBack)
}

export const eqUserAppointConcel = (params = {}, okCallBack, errCallBack) => { //2.1.24预约取消
    return http('POST', servers.eqUserAppointConcel, params, okCallBack, errCallBack)
}

export const receiveAppoint = (params = {}, okCallBack, errCallBack) => { //2.1.24预约取消
    return http('POST', servers.receiveAppoint, params, okCallBack, errCallBack)
}

export const getEqAuditList = (params = {}, okCallBack, errCallBack) => { //2.1.19预约审核列表
    return http('GET', servers.eqAuditList, params, okCallBack, errCallBack)
}

export const eqAudit = (params = {}, okCallBack, errCallBack) => { //2.1.21预约审核（含批量）
    return http('POST', servers.eqAudit, params, okCallBack, errCallBack)
}

export const getEqAuditInfo = (params = {}, okCallBack, errCallBack) => { //2.1.20预约审核信息初始化
    return http('GET', servers.eqAuditInfo, params, okCallBack, errCallBack)
}

export const getVoteList = (params = {}, okCallBack, errCallBack) => { //2.1.28问卷管理列表/查询
    return http('GET', servers.voteList, params, okCallBack, errCallBack)
}

export const voteSubmit = (params = {}, okCallBack, errCallBack) => { //2.1.29问卷管理新增/修改
    return http('POST', servers.voteSubmit, params, okCallBack, errCallBack)
}

export const voteSub = (params = {}, okCallBack, errCallBack) => { //2.1.33投票
    return http('POST', servers.voteSub, params, okCallBack, errCallBack)
}

export const voteDel = (params = {}, okCallBack, errCallBack) => { //2.1.30问卷管理删除
    return http('POST', servers.voteDel, params, okCallBack, errCallBack)
}

export const getVoteInfo = (params = {}, okCallBack, errCallBack) => { //2.1.34问卷详情（包含个人投票结果）
    return http('GET', servers.voteInfo, params, okCallBack, errCallBack)
}

export const getVoteStatic = (params = {}, okCallBack, errCallBack) => { //2.1.31问卷管理详情
    return http('GET', servers.voteStatic, params, okCallBack, errCallBack)
}

export const getVoteMyList = (params = {}, okCallBack, errCallBack) => { //问卷列表
    return http('GET', servers.voteMyList, params, okCallBack, errCallBack)
}

export const getUserCredit = (params = {}, okCallBack, errCallBack) => { //2.1.42我的信用
    return http('GET', servers.userCredit, params, okCallBack, errCallBack)
}

export const getUserApplyList = (params = {}, okCallBack, errCallBack) => { //2.1.35待审核人员列表/查询
    return http('GET', servers.userApplyList, params, okCallBack, errCallBack)
}

export const userApplyInfo = (params = {}, okCallBack, errCallBack) => { //2.1.37人员审核
    return http('GET', servers.userApplyInfo, params, okCallBack, errCallBack)
}

export const userApplyAudi = (params = {}, okCallBack, errCallBack) => { //2.1.37人员审核
    return http('POST', servers.userApplyAudi, params, okCallBack, errCallBack)
}

export const getOrgApplyList = (params = {}, okCallBack, errCallBack) => { //2.1.37人员审核
    return http('GET', servers.orgApplyList, params, okCallBack, errCallBack)
}

export const getLabIni = (params = {}, okCallBack, errCallBack) => { //2.1.39实验室审核信息初始化
    return http('GET', servers.getLabIni, params, okCallBack, errCallBack)
}

export const audiLab = (params = {}, okCallBack, errCallBack) => { //2.1.40实验室审核
    return http('GET', servers.audiLab, params, okCallBack, errCallBack)
}

export const getStEqInfo = (params = {}, okCallBack, errCallBack) => { //2.4.1最近一周设备预约及使用次数接口
    return http('GET', servers.stEqInfo, params, okCallBack, errCallBack)
}

export const getStEqTop = (params = {}, okCallBack, errCallBack) => { //2.4.2设备预约及使用次数前十明细接口
    return http('GET', servers.stEqTop, params, okCallBack, errCallBack)
}

export const getStEqAppointOut = (params = {}, okCallBack, errCallBack) => { //2.4.3最近一周内外部人员预约使用情况接口
    return http('GET', servers.stEqAppointOut, params, okCallBack, errCallBack)
}

export const getStEqAppointTop = (params = {}, okCallBack, errCallBack) => { //2.4.4人员预约次数前十接口
    return http('GET', servers.stEqAppointTop, params, okCallBack, errCallBack)
}

export const getStEqUseTimeTop = (params = {}, okCallBack, errCallBack) => { //2.4.5TOP10使用时长接口
    return http('GET', servers.stEqUseTimeTop, params, okCallBack, errCallBack)
}

export const getStEqUseInfoTop = (params = {}, okCallBack, errCallBack) => { //2.4.6最近一周设备使用情况接口
    return http('GET', servers.stEqUseInfoTop, params, okCallBack, errCallBack)
}

export const getStEqBadInfoTop = (params = {}, okCallBack, errCallBack) => { //2.4.7最近一年设备故障率情况接口
    return http('GET', servers.stEqBadInfoTop, params, okCallBack, errCallBack)
}

export const getStUserCreditInfo = (params = {}, okCallBack, errCallBack) => { //2.4.8人员信用情况接口
    return http('GET', servers.stUserCreditInfo, params, okCallBack, errCallBack)
}

export const getStPiCreditInfo = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.stPiCreditInfo, params, okCallBack, errCallBack)
}

export const refreshCheckCode = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.refreshCheckCode, params, okCallBack, errCallBack)
}

export const getPiListlab = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.getPiList, params, okCallBack, errCallBack)
}

export const addPi = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.addPi, params, okCallBack, errCallBack)
}

export const getPiInfo = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.getPiInfo, params, okCallBack, errCallBack)
}

export const deletePi = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.deletePi, params, okCallBack, errCallBack)
}

export const addImportUser = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.addImportUser, params, okCallBack, errCallBack)
}

export const getPiUserListByPi = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.getPiUserListByPi, params, okCallBack, errCallBack)
}

export const delUser = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.delUser, params, okCallBack, errCallBack)
}

export const piGetInitial = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.piGetInitial, params, okCallBack, errCallBack)
}

export const getUsingPrince = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.getUsingPrince, params, okCallBack, errCallBack)
}

export const repairList = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.repairList, params, okCallBack, errCallBack)
}
export const repairInfo = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.repairInfo, params, okCallBack, errCallBack)
}
export const addRepair = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.addRepair, params, okCallBack, errCallBack)
}
export const delRepair = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.delRepair, params, okCallBack, errCallBack)
}
export const repairAdmin = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.repairAdmin, params, okCallBack, errCallBack)
}
export const repairAffirm = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.repairAffirm, params, okCallBack, errCallBack)
}
export const repairFeedback = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.repairFeedback, params, okCallBack, errCallBack)
}

export const dealAllMsgReadPost = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.dealAllMsgReadPost, params, okCallBack, errCallBack)
}

export const getStRepairInfo = (params = {}, okCallBack, errCallBack) => { //2.4.9PI组信用排名接口
    return http('GET', servers.getStRepairInfo, params, okCallBack, errCallBack)
}

export const getCWList = (params = {}, okCallBack, errCallBack) => { //2.1.1报账分配列表接口
    return http('GET', servers.getCWList, params, okCallBack, errCallBack)
}

export const cwUpdate = (params = {}, okCallBack, errCallBack) => { //2.1.2项目创建/分配/修改接口
    return http('GET', servers.cwUpdate, params, okCallBack, errCallBack)
}

export const modeList = (params = {}, okCallBack, errCallBack) => { //2.1.2项目创建/分配/修改接口
    return http('GET', servers.modeList, params, okCallBack, errCallBack)
}

export const getPiEqInfo = (params = {}, okCallBack, errCallBack) => { //获取课题组设备预约使用时间和次数
    return http('GET', servers.getPiEqInfo, params, okCallBack, errCallBack)
}

